import React, { useEffect, useState } from "react";
import { Button, Row, Col, Image } from 'antd';
import { Link } from "react-router-dom";
import sal from 'sal.js';
import "./LandingStyles.css";

// Métiers — hero device frame
import ImgPeintre from '../../media/peintre-recto.webp';
import ImgPeintreVerso from '../../media/peintre-verso.webp';
import ImgPompier from '../../media/pompier-recto.webp';
import ImgPompierVerso from '../../media/pompier-verso.webp';
import ImgCharpentier from '../../media/charpentier-recto.webp';
import ImgCharpentierVerso from '../../media/charpentier-verso.webp';
import ImgInfirmier from '../../media/infirmier-recto.webp';
import ImgInfirmierVerso from '../../media/infirmier-verso.webp';
import ImgLabo from '../../media/labo-recto.webp';
import ImgLaboVerso from '../../media/labo-verso.webp';
import ImgConducteur from '../../media/conducteur-train-recto.webp';
import ImgConducteurVerso from '../../media/conducteur-train-verso.webp';
import ImgSoudeur from '../../media/soudeur-recto.webp';
import ImgSoudeurVerso from '../../media/soudeur-verso.webp';
import ImgMacon from '../../media/macon-recto.webp';
import ImgMaconVerso from '../../media/macon-verso.webp';

// Galerie fonctionnalités
import GalExpositions from '../../media/featureGallery/expositions.webp';
import GalCoExpositions from '../../media/featureGallery/co-expositions.webp';
import GalExamenClinique from '../../media/featureGallery/examen-clinique.webp';
import GalSuiviRecommandations from '../../media/featureGallery/suivi-et-recommandations.webp';
import GalOrdonnance from '../../media/featureGallery/ordonnance-de-prevention.webp';
import GalGenerationDocuments from '../../media/featureGallery/generation-de-documents.webp';
import GalCursusTaches from '../../media/featureGallery/cursus-et-taches.webp';
import GalVfcEligibilite from '../../media/featureGallery/vfc-eligibilite.webp';
import GalDocumentChecklist from '../../media/featureGallery/document-checklist.webp';
import GalAideIa from '../../media/featureGallery/aide-ia.webp';
import GalMatricesSurMesure from '../../media/featureGallery/matrices-sur-mesure.webp';
import GalEditeurMatrices from '../../media/featureGallery/editeur-de-matrices-collaboratif.webp';
import GalHarmoniserPratiques from '../../media/featureGallery/harmoniser-les-pratiques.webp';
import GalFluxSirh from '../../media/featureGallery/flux-sirh.webp';
import GalIaSalaries from '../../media/featureGallery/ia-salariés.webp';
import GalSuiviSante from '../../media/featureGallery/suivi-sante.webp';
import GalMaladiesProfessionnelles from '../../media/featureGallery/maladies-professionnelles.webp';

// Labels
import LogoFrenchTech from '../../media/labels/frenchtech-logo.webp';
import LogoFrance2030 from '../../media/labels/france2030-logo.webp';
import LogoANS from '../../media/labels/ans-logo.webp';
import LogoHDS from '../../media/labels/hds-logo.webp';

import { ARTICLES as ALL_ARTICLES, CATEGORIE_COLORS as CATEGORIE_COLORS_BLOG } from '../../data/articles';

// La home met en avant les dernières actualités : on exclut l'annuaire SPSTI
// (contenu de référence, sans image de couverture).
const ARTICLES = ALL_ARTICLES.filter((a) => a.categorie !== "Annuaire SPSTI").slice(0, 3);

const CIBLES = [
  { key: 'medecins',    label: 'Professionnels de santé',    cols: [[GalCursusTaches, GalExpositions, GalCoExpositions], [GalAideIa, GalExamenClinique, GalSuiviRecommandations], [GalOrdonnance, GalGenerationDocuments]] },
  { key: 'salaries',    label: 'Salariés',                   cols: [[GalSuiviSante, GalCursusTaches], [GalDocumentChecklist, GalIaSalaries], [GalVfcEligibilite, GalMaladiesProfessionnelles]] },
  { key: 'entreprises', label: 'Services de Santé au travail', cols: [[GalMatricesSurMesure], [GalHarmoniserPratiques, GalFluxSirh], [GalEditeurMatrices]] },
];


function CategorieBadgeBlog({ categorie }) {
  const style = CATEGORIE_COLORS_BLOG[categorie] || CATEGORIE_COLORS_BLOG["Actualité"];
  return (
    <span className="blog-badge" style={{ background: style.bg, color: style.color }}>
      {categorie}
    </span>
  );
}

const FAQ_CATEGORIES = [
  {
    key: 'reglementation',
    label: 'Réglementation et Obligations',
    questions: [
      {
        q: "Comment la plateforme RAVAIL aide-t-elle à respecter la loi Santé au Travail du 2 août 2021 ?",
        a: "La loi du 2 août 2021 renforce la prévention en entreprise et la traçabilité des expositions, avec un accent majeur sur la fin de carrière. RAVAIL aide les Services de Prévention et de Santé au Travail (SPST) à se mettre en conformité en facilitant la reconstitution des parcours professionnels complets et en générant l'état des lieux des expositions exigé par la loi, facilitant ainsi la mise en place du suivi post-exposition ou post-professionnel à grande échelle.",
      },
      {
        q: "Que dit le Code du travail sur les visites médicales de mi-carrière et de fin de carrière ?",
        a: "Le Code du travail impose une visite de mi-carrière l'année des 45 ans du travailleur (ou à une date fixée par accord de branche) pour évaluer l'adéquation entre son poste et son état de santé (Art. L4624-2-2). Elle est aussi un point d'étape essentiel dans le suivi de carrière pour évaluer si les suivis recommandés en lien avec les expositions antérieures sont bien mises en place. La visite de fin de carrière (Art. L4624-2-1) est quant à elle destinée aux travailleurs bénéficiant ou ayant bénéficié d'un Suivi Individuel Renforcé (SIR), afin d'établir une traçabilité de leurs expositions professionnelles avant le départ à la retraite, à transmettre à la médecine de ville qui assurera la continuité du suivi.",
      },
      {
        q: "Quelles sont les sanctions encourues par l'employeur en cas de défaut de suivi médical ?",
        a: "L'employeur a une obligation de sécurité de résultat envers ses salariés. Le défaut d'organisation des visites médicales obligatoires constitue une faute. L'employeur s'expose à des sanctions pénales (amendes), au paiement de dommages et intérêts au salarié pour préjudice subi, et surtout à la reconnaissance d'une faute inexcusable en cas d'accident du travail ou de maladie professionnelle.",
      },
      {
        q: "Comment adhérer à un Service de Prévention et de Santé au Travail (SPST) et quel en est le coût ?",
        a: "Toute entreprise du secteur privé a l'obligation d'adhérer à un SPST interentreprises si elle ne dispose pas de son propre service autonome. L'adhésion se fait directement auprès d'un des services compétents pour votre zone géographique ou votre secteur d'activité. Le coût prend la forme d'une cotisation annuelle par salarié, dont le montant est fixé par le conseil d'administration du SPST (généralement entre 80 € et 150 € par an et par salarié).",
      },
      {
        q: "Est-ce que la visite de mi-carrière (à 45 ans) est obligatoire pour tous les salariés ?",
        a: "Instaurée par la loi du 2 août 2021, la visite médicale de mi-carrière est obligatoire pour tous les salariés l'année de leurs 45 ans, à moins qu'un accord de branche ne fixe une autre échéance. Elle vise à anticiper les risques de désinsertion professionnelle et à adapter le poste de travail si nécessaire.",
      },
      {
        q: "Qu'est-ce que la visite de fin de carrière et qui est concerné ?",
        a: <>La visite de fin de carrière est un examen médical obligatoire pour les salariés qui partent à la retraite et qui ont bénéficié au cours de leur vie d'un Suivi Individuel Renforcé (SIR), ou qui ont été exposés à certains risques majeurs (amiante, plomb, agents cancérogènes...). Elle permet de tracer les expositions et de mettre en place une surveillance médicale post-professionnelle le cas échéant. Vous pouvez vérifier l'éligibilité d'un salarié via notre <Link to="/test-eligibilite-vfc">test d'éligibilité VFC</Link>.</>,
      },
      {
        q: "Quand doit-on passer la visite médicale du travail ?",
        a: "La périodicité dépend du type de suivi déclaré par votre employeur et de votre état de santé. En règle générale, la visite d'Information et de Prévention (VIP) a lieu au maximum tous les 5 ans. Pour les travailleurs de nuit, les mineurs ou les personnes handicapées, ce délai est réduit à 3 ans. Pour les postes à risques (SIR), la visite médicale avec le médecin s'effectue tous les 4 ans, avec un entretien intermédiaire infirmier à 2 ans. Il convient de préciser que la périodicité peut varier selon des éléments particuliers liés à votre santé, il faut donc se référer à la date limite de prochaine visite mentionnée dans votre dernier avis d'aptitude ou attestation de suivi. Une visite à la demande du salarié, de l'employeur ou du médecin du travail peut être sollicitée à tout moment.",
      },
      {
        q: "Que faire si mon entreprise n'a pas de médecine du travail ?",
        a: "Si vous êtes salarié, votre employeur est dans l'illégalité (hors cas particuliers), car l'affiliation à un SPST est une obligation légale stricte. En tant que salarié, vous pouvez le signaler à vos représentants du personnel (CSE) ou contacter directement l'Inspection du Travail pour faire valoir votre droit au suivi médical.",
      },
    ],
  },
  {
    key: 'fonctionnalites',
    label: 'Fonctionnalités du Logiciel',
    questions: [
      {
        q: "Quelles sont les bases de données et matrices d'expositions sur lesquelles RAVAIL s'appuie pour ses analyses ?",
        a: "L'algorithme de RAVAIL croise les informations saisies avec des bases de données institutionnelles de référence. L'outil s'appuie précisément sur les matrices emplois-tâches et les matrices emplois-expositions du réseau Présanse et, pour aller plus loin dans la finesse d'analyse, RAVAIL dispose également de sa propre matrice tâches-expositions. Nous mettons en œuvre également des matrices emploi-exposition-intensité et tâches-exposition-intensité ainsi qu'une base de données de questions supplémentaires, permettant de se rattacher aux recommandations des sociétés savantes lors de l'évaluation des intensités globales d'exposition. La combinaison de ces référentiels permet de relier scientifiquement un métier, et surtout chaque tâche précise effectuée par le salarié, à une probabilité et une intensité d'exposition à des risques spécifiques (chimiques, physiques, biologiques). Cette méthode garantit au praticien un repérage précis, standardisé et solidement documenté lorsque cela est possible. En l'absence de critères standardisés, il est possible d'en définir à l'échelle de son service de santé au travail pour harmoniser les pratiques, gagner en reproductibilité, efficacité et cohérence.",
      },
      {
        q: "Comment le salarié peut-il préparer sa visite de mi-carrière ou de fin de carrière en amont via la plateforme ?",
        a: "Avant la consultation, le salarié reçoit un lien unique et sécurisé qui lui permet d'accéder à une interface simplifiée où il peut renseigner son parcours professionnel, ses différents postes, et les tâches et expositions auxquelles il pense avoir été confronté. La saisie des informations par le salarié peut s'effectuer par dictée vocale multilingue pour en faciliter l'accessibilité, grâce à une thésaurisation automatique des métiers les plus proches par intelligence artificielle. Ces données sont ensuite directement ajoutées à la visite avant son arrivée au cabinet, libérant ainsi du temps au consultant.",
      },
      {
        q: "Comment RAVAIL facilite-t-il l'analyse fine des expositions professionnelles passées du travailleur ?",
        a: "Grâce aux informations recueillies, RAVAIL cartographie automatiquement la carrière du salarié. Il met en lumière les périodes de risques et co-expositions spécifiques (chimiques, physiques, biologiques, ergonomiques…) en suggérant des intensités globales d'exposition et certitudes, selon un référentiel des recommandations réglementaires et scientifiques préconisées par les sociétés savantes (SFST, HAS, INRS, INCa, MedSubHyp…), issues du travail de synthèse effectué lors de la thèse de Quentin NOCTURE du 28 mars 2024, puis actualisé régulièrement. Cela offre au médecin une vue d'ensemble immédiate, claire et structurée pour mieux orienter son interrogatoire et ses conseils sur les facteurs de risque modifiables. Cela permet aussi de cibler l'examen clinique sur les pathologies susceptibles d'être associées aux expositions professionnelles passées pour lutter contre la sous-identification et indirectement la sous-déclaration des maladies professionnelles.",
      },
      {
        q: "Comment RAVAIL détermine-t-il les suggestions de suivi médical et post-exposition pour les salariés ?",
        a: "L'outil analyse l'historique des expositions du salarié et le confronte aux recommandations médicales en vigueur. RAVAIL suggère automatiquement les suivis adaptés, la nature des examens complémentaires indiqués (examen clinique, radiographies, audiogrammes, etc.), leur fréquence et la date à laquelle ces suivis doivent être débutés. En effet, nous avons traduit l'ensemble des recommandations scientifiques règlementaires en des règles de décision affectées à des seuils pour chacun de ces éléments. Si tous les critères sont réunis, l'outil suggérera l'intensité globale d'exposition et la certitude associées, qui une fois validées par le médecin permettront de déterminer le suivi et les examens adaptés.",
      },
      {
        q: "Est-ce que le logiciel RAVAIL permet de déléguer une partie de la visite aux infirmiers en santé au travail (IDEST) ?",
        a: "RAVAIL a été pensé pour faciliter et fluidifier la délégation des tâches. Les IDEST peuvent mener l'entretien de recueil des données en s'appuyant sur la trame structurée de l'outil. Si les éléments recueillis mettent en évidence une exposition ou une situation nécessitant une expertise médicale, l'infirmier est alerté et dispose de tous les éléments objectivés par le logiciel pour transmettre le dossier pré-complété au médecin du travail.",
      },
      {
        q: "Quels documents RAVAIL génère-t-il à l'issue de la consultation ?",
        a: "Pour réduire la charge administrative, RAVAIL facilite la création de l'ensemble des documents indispensables à la clôture d'une visite et édite notamment une synthèse et un compte-rendu détaillé, retraçant de manière fidèle et structurée l'état des lieux des expositions et les éléments de la visite. Le professionnel de santé peut aussi générer des recommandations de dépistage ciblées ainsi que des ordonnances de prévention personnalisées pour les postes actuels selon les risques identifiés. Ces documents aident le salarié à devenir acteur de sa propre santé tout en encadrant médicalement les suites de la visite. Enfin, RAVAIL génère également des courriers pour le médecin traitant, pensés pour être synthétiques et exploitables, permettant d'assurer un relais efficace du suivi prescrit, garantissant que les informations sur les expositions passées ne se perdent pas lors du départ à la retraite. Actuellement, les attestations de suivi, avis d'aptitude, d'inaptitude et annexes 4 ne sont pas générés par notre outil, qui est complémentaire des autres logiciels de santé au travail.",
      },
    ],
  },
  {
    key: 'organisation',
    label: 'Organisation et Démarches Pratiques',
    questions: [
      {
        q: "Comment l'outil gère-t-il la reconstitution des parcours professionnels longs, fragmentés ou multi-employeurs ?",
        a: "Les carrières hachées (intérim, CDD multiples…) sont un défi majeur en santé au travail. RAVAIL propose une interface chronologique intuitive. Le salarié et le praticien peuvent facilement y ajouter ou modifier des périodes de travail de manière fluide, évitant le casse-tête des Curriculum Laboris sur papier. Une option de saisie vocale par IA multilingue permet également de faciliter la thésaurisation des métiers, tâches et expositions en calculant automatiquement les dates clés.",
      },
      {
        q: "Comment RAVAIL aide-t-il à identifier les co-expositions à risque et une possible origine professionnelle aux maladies ?",
        a: "Le logiciel est capable de croiser les différents risques identifiés tout au long du parcours du travailleur. S'il détecte qu'un salarié a été exposé simultanément ou successivement à plusieurs facteurs de risques complémentaires (par exemple, au bruit et à des agents ototoxiques), l'outil identifie et signale cette co-exposition. Il incite aussi à rechercher les autres co-expositions associées aux mêmes maladies, représentées de manière visuelle sous forme d'une cartographie individuelle des facteurs de risque. L'interrogatoire est orienté par l'outil pour éviter les redondances tout en facilitant l'exhaustivité du recueil. Cette analyse fine permet au professionnel de santé de mieux évaluer l'impact global sur la santé du travailleur et d'orienter plus facilement ses démarches et ses conseils, notamment en cas de suspicion de maladie professionnelle.",
      },
      {
        q: "Comment le secret médical et la sécurité des données saisies par les salariés sont-ils garantis ?",
        a: "La sécurité des données et le respect du secret médical sont nos priorités. RAVAIL est hébergé en France sur des serveurs certifiés HDS (Hébergeur de Données de Santé). L'ensemble des données est protégé par chiffrement lors de leur transit (via HTTPS avec TLS v1.2 minimum requis pour accéder au site) ainsi qu'au repos (derniers standards cryptographiques recommandés par l'ANSSI). Par ailleurs, l'outil est strictement conforme au RGPD. Seuls les professionnels de santé habilités peuvent accéder aux informations médicales.",
      },
      {
        q: "Comment RAVAIL simplifie-t-il la rédaction de l'état des lieux des expositions exigé lors de la visite de fin de carrière ?",
        a: "RAVAIL effectue une synthèse claire des éléments recueillis les plus pertinents à transmettre au salarié et aux correspondants impliqués dans son parcours de santé. Ces informations comprennent notamment la nature des expositions, l'intensité globale et la certitude d'exposition, si des suivis sont recommandés ou proposés, leur nature, fréquence et délais conseillés avant mise en place. Il produit également un document PDF normé et exhaustif, prêt à être remis au salarié et à son médecin traitant, recensant l'ensemble des éléments recueillis lors de la visite.",
      },
      {
        q: "Comment la plateforme permet-elle aux médecins du travail de gagner du temps tout en sécurisant leurs décisions ?",
        a: "En déléguant le recueil des données au salarié, au personnel administratif ou à l'IDEST ainsi qu'en automatisant le repérage des risques via ses matrices d'exposition, RAVAIL limite la double saisie et simplifie le travail de recherche bibliographique en justifiant ses suggestions et ses sources, qui sont accessibles à la volée. Le médecin gagne un temps médical précieux pour se concentrer sur l'humain et le conseil avec une approche beaucoup plus globale et moins centrée sur le seul métier actuel.",
      },
    ],
  },
  {
    key: 'acteurs',
    label: 'Acteurs, Prévention et Coûts',
    questions: [
      {
        q: "Est-ce que RAVAIL a été conçu par des experts métiers ?",
        a: "RAVAIL est le fruit de la collaboration entre des médecins du travail en exercice (service interentreprises et autonome) et des ingénieurs informatiques. Cette double expertise a servi de fondement au développement de l'outil, qui a été construit dès l'origine autour du besoin et du raisonnement médical, ce qui garantit que l'outil réponde aux véritables exigences du terrain.",
      },
      {
        q: "Comment la plateforme rend-elle le salarié acteur de son propre parcours de santé au travail ?",
        a: "En l'invitant à remplir son historique avant la visite, RAVAIL invite le travailleur à un effort de mémoire et de réflexion sur ses propres conditions de travail. Cette démarche proactive facilite le dialogue en consultation et sensibilise le salarié aux enjeux de sa santé à long terme. Elle permet ensuite la mise à jour des informations recueillies lors des visites ultérieures, pour s'assurer que le suivi soit toujours adapté en regard du présent mais aussi du passé professionnel. L'accès à une synthèse visuelle exploitable du suivi indiqué et des raisons de ces prescriptions contribue à améliorer l'observance au parcours de soin, grâce à une meilleure compréhension.",
      },
      {
        q: "Est-ce que l'interface de RAVAIL nécessite une formation complexe pour les professionnels de santé ?",
        a: "L'interface a été conçue pour être aussi intuitive que les applications que vous utilisez au quotidien. Une présentation initiale suffit pour la prise en main. La navigation est pensée pour éviter la surcharge cognitive des praticiens. Fonctionnant directement dans votre navigateur web, il ne nécessite aucune installation lourde sur vos postes informatiques. Des messages d'aide ou d'information sont accessibles directement depuis l'interface de visite, pour répondre aux éventuelles questions de l'utilisateur.",
      },
      {
        q: "Quels professionnels peuvent utiliser RAVAIL et comment la plateforme est-elle déployée ?",
        a: "RAVAIL s'adresse aux Services de Prévention et de Santé au Travail Interentreprises (SPSTI) ainsi qu'aux services autonomes de grandes entreprises. Le déploiement se fait via la création d'accès web sécurisés pour vos équipes médicales, paramédicales et administratives, sans interruption de vos services actuels. En effet, nos outils étant complémentaires des logiciels métiers existants, il n'est pas nécessaire d'en changer.",
      },
      {
        q: "Comment les informations recueillies par RAVAIL contribuent-elles à la prévention en entreprise ?",
        a: "Bien que RAVAIL se concentre avant tout sur le parcours individuel du salarié, la précision des informations recueillies lors des visites périodiques, de mi-carrière et de fin de carrière est un atout majeur pour la prévention. En objectivant les expositions réelles d'un ou plusieurs collaborateurs à certains postes, le médecin du travail dispose d'éléments concrets pour conseiller l'employeur. Il peut ainsi formuler des recommandations ciblées pour adapter les postes de travail ou réduire les risques à la source, participant ainsi indirectement à la démarche d'évaluation des risques de l'entreprise pour les métiers actuels. Par ailleurs, RAVAIL génère une ordonnance de prévention à remettre au salarié, donnant des conseils personnalisés (selon son métier actuel, ses tâches, ses expositions, son sexe, etc…) et des recommandations pour se prémunir des risques et contribuer à la prévention en entreprise.",
      },
    ],
  },
  {
    key: 'rdv',
    label: 'Prise de Rendez-vous et Démarches',
    questions: [
      {
        q: "Est-ce qu'un salarié peut demander un rendez-vous avec la médecine du travail de sa propre initiative ?",
        a: "Un salarié peut à tout moment demander une visite médicale avec le médecin du travail de son entreprise, indépendamment des visites obligatoires. Le motif de la demande de visite est confidentiel et l'employeur n'a pas à le connaître.",
      },
      {
        q: "Quels documents apporter pour une visite médicale du travail ?",
        a: "Pour une visite optimale, il est recommandé d'apporter : votre carnet de santé ou de vaccination, vos lunettes de vue ou prescriptions récentes, vos examens médicaux récents (radiographies, prises de sang, bilans spécialistes), votre relevé de carrière CNAV et votre reconnaissance de la qualité de travailleur handicapé (RQTH) le cas échéant. En complément, RAVAIL établit automatiquement la liste des documents importants à rapporter, selon les métiers et expositions de chaque salarié.",
      },
      {
        q: "Comment obtenir une copie de son dossier médical en santé au travail ?",
        a: "Le dossier médical en santé au travail vous concernant vous appartient. Vous devez adresser une demande écrite (par courrier ou via l'interface du SPST) à la direction de votre centre de médecine du travail. Le dossier vous sera transmis directement ou envoyé au médecin de votre choix, selon vos indications.",
      },
    ],
  },
  {
    key: 'role-acteurs',
    label: 'Rôle des Acteurs et Déroulement',
    questions: [
      {
        q: "Quel est le rôle exact du médecin du travail ?",
        a: "Le médecin du travail a un rôle exclusivement préventif. Sa mission est d'éviter toute altération de la santé des travailleurs du fait de leur travail. Il agit comme conseiller auprès de l'employeur et des salariés pour améliorer les conditions de travail, adapter les postes et prévenir les risques professionnels. Il ne prescrit ni soins (sauf en cas d'urgence), ni arrêts de travail.",
      },
      {
        q: "Que dire au médecin du travail lors de sa visite médicale ?",
        a: "Vous pouvez tout lui dire. L'échange est couvert par le secret médical absolu. Il est essentiel d'être transparent sur vos conditions de travail réelles, votre niveau de stress, vos douleurs physiques, et vos antécédents médicaux, addictions, afin que le praticien puisse vous conseiller et orienter au mieux ou proposer des aménagements de poste pertinents.",
      },
      {
        q: "Comment se passe concrètement une visite médicale du travail ?",
        a: "La visite (qui dure généralement entre 15 et 30 minutes) débute par un entretien sur votre parcours, vos conditions de travail actuelles et votre ressenti. Si la visite est effectuée par un médecin, elle se poursuit par un examen clinique classique (tension, vue, audition, etc.). Enfin, le médecin (ou l'infirmier) fait le point avec vous, vous délivre des conseils de prévention et vous remet votre attestation de suivi ou votre avis d'aptitude.",
      },
    ],
  },
];

const LABELS = [
  {
    key: 'frenchtech',
    logo: LogoFrenchTech,
    alt: 'FrenchTech',
    text: 'RAVAIL est soutenu par la FrenchTech',
  },
  {
    key: 'france2030',
    logo: LogoFrance2030,
    alt: 'France 2030',
    text: 'RAVAIL est soutenu par France 2030',
  },
  {
    key: 'ans',
    logo: LogoANS,
    alt: 'ANS e-santé',
    text: 'RAVAIL est lauréat des talents de la e-santé 2024, catégorie prévention, organisé par l\'Agence du Numérique en Santé (ANS)',
  },
  {
    key: 'hds',
    logo: LogoHDS,
    alt: 'HDS / ISO 27001',
    text: 'Données et outils hébergés en France, certifiés HDS 6 niveaux.',
  },
];

const METIERS = [
  { key: 'peintre',    recto: ImgPeintre,    verso: ImgPeintreVerso,    alt: 'Peintre' },
  { key: 'pompier',    recto: ImgPompier,    verso: ImgPompierVerso,    alt: 'Pompier' },
  { key: 'charpentier',recto: ImgCharpentier,verso: ImgCharpentierVerso,alt: 'Charpentier' },
  { key: 'infirmier',  recto: ImgInfirmier,  verso: ImgInfirmierVerso,  alt: 'Infirmier' },
  { key: 'labo',       recto: ImgLabo,       verso: ImgLaboVerso,       alt: 'Laborantin' },
  { key: 'conducteur', recto: ImgConducteur, verso: ImgConducteurVerso, alt: 'Conducteur de train' },
  { key: 'soudeur',    recto: ImgSoudeur,    verso: ImgSoudeurVerso,    alt: 'Soudeur' },
  { key: 'macon',      recto: ImgMacon,      verso: ImgMaconVerso,      alt: 'Maçon' },
];


function LandingPage(props) {
  const [flipped, setFlipped] = useState({});
  const [activeCible, setActiveCible] = useState('medecins');
  const [slideDir, setSlideDir] = useState('right');
  const [activeCat, setActiveCat] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFlip = (key) => {
    setFlipped(prev => ({ ...prev, [key]: !prev[key] }));
  };

  useEffect(() => {
    sal();
  }, []);

  return (
    <>
      <section className="hero-section">
        <div className="containerAccueil">
          <Row className="hero-row" align="middle">
            <Col xs={24} lg={10} className="hero-text-col" data-sal="slide-up" data-sal-duration="500">
              <h1 className="hero-title">L’innovation digitale au service du suivi de carrière</h1>
              <div className="hero-buttons" data-sal="zoom-out" data-sal-duration="700" data-sal-delay="300">
                <Link to="/contact?tab=demo">
                  <Button type="primary" size="large" className="hero-btn-primary">
                    Demandez une démo
                  </Button>
                </Link>
                <Link to="/contact">
                  <Button size="large" className="hero-btn-secondary">
                    Nous contacter
                  </Button>
                </Link>
              </div>
            </Col>
            <Col xs={24} lg={14} className="hero-device-col" data-sal="slide-left" data-sal-duration="700">
              <div className="device-frame">
                <div className="device-titlebar" />
                <div className="device-grid">
                  {METIERS.map(({ key, recto, verso, alt }, metierIndex) => {
                    const isFirst = metierIndex === 0;
                    return (
                      <div
                        key={key}
                        className={`device-img-wrap${flipped[key] ? ' is-flipped' : ''}`}
                        onClick={() => toggleFlip(key)}
                      >
                        <img
                          src={recto}
                          srcSet={`${recto} 1x`}
                          alt={alt}
                          className="device-img device-img-recto"
                          {...(isFirst ? { fetchpriority: "high" } : {})}
                        />
                        {verso && (
                          <img
                            src={verso}
                            srcSet={`${verso} 1x`}
                            alt={`${alt} verso`}
                            className="device-img device-img-verso"
                            loading="lazy"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <div className="wave-hero-to-pf" aria-hidden="true">
        <svg viewBox="0 0 1280 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 120 H1280 V60 C1000 0 300 120 0 40 Z" fill="#fefefe"/>
        </svg>
      </div>
      <section className="section-points-forts">
        <div className="fg-inner">
          <div className="pf-header">
            <h2 className="pf-title">Nos points forts</h2>
            <p className="pf-subtitle">En trois points pour commencer.</p>
          </div>
          <Row className="pf-cards" gutter={[32, 24]} style={{ alignItems: 'stretch' }}>
            <Col xs={24} md={8} data-sal="slide-up" data-sal-duration="700">
              <div className="pf-card pf-card--blue">
                <span className="pf-dot pf-dot--green" />
                <p>Accès facile et sécurisé depuis votre navigateur</p>
              </div>
            </Col>
            <Col xs={24} md={8} data-sal="slide-up" data-sal-duration="700" data-sal-delay="150">
              <div className="pf-card pf-card--cyan">
                <span className="pf-dot pf-dot--blue" />
                <p>Dernières recommandations scientifiques et réglementaires</p>
              </div>
            </Col>
            <Col xs={24} md={8} data-sal="slide-up" data-sal-duration="700" data-sal-delay="300">
              <div className="pf-card pf-card--green">
                <span className="pf-dot pf-dot--cyan" />
                <p>Comptes-rendus synthétiques et courriers types personnalisés</p>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="section-feature-gallery">
        <div className="fg-inner">
          <div className="fg-header">
            <h2 className="fg-title">VISI<span style={{ color: "#76e297" }}>E</span> vous simplifie la visite</h2>
            <p className="fg-subtitle">Retrouvez nos fonctionnalités clés.</p>
          </div>
          <div className="fg-tabs">
            {CIBLES.map(({ key, label }) => (
              <button
                key={key}
                className={`fg-tab${activeCible === key ? ' fg-tab--active' : ''}`}
                onClick={() => {
                  const currentIdx = CIBLES.findIndex(c => c.key === activeCible);
                  const nextIdx = CIBLES.findIndex(c => c.key === key);
                  setSlideDir(nextIdx > currentIdx ? 'right' : 'left');
                  setActiveCible(key);
                }}
              >
                {label}
              </button>
            ))}
          </div>
          <Image.PreviewGroup>
            {(() => {
              const { cols } = CIBLES.find(c => c.key === activeCible);
              if (!cols.length) return null;
              return (
                <div className={`fg-gallery fg-slide fg-slide--${slideDir}`} key={activeCible}>
                  {cols.map((colImgs, colIndex) => (
                    <div key={colIndex} className="fg-col">
                      {colImgs.map((src, i) => (
                        <Image key={i} src={src} alt={`Fonctionnalité ${colIndex}-${i}`} className="fg-img" loading="lazy" />
                      ))}
                    </div>
                  ))}
                </div>
              );
            })()}
          </Image.PreviewGroup>
          <div className="fg-cta">
            <Link to="/notre-solution" className="fg-cta-btn">Découvrez toutes nos fonctionnalités →</Link>
          </div>
        </div>
      </section>
      <section className="section-labels">
        <div className="fg-inner">
          <div className="labels-header">
            <h2 className="labels-title">Nos labels</h2>
            <p className="labels-subtitle">Notre solution est reconnue et certifiée.</p>
          </div>
        </div>
        <div className="labels-track-wrapper">
          <div className="labels-track">
            {[...LABELS, ...LABELS].map(({ key, logo, alt, text }, i) => (
              <div key={`${key}-${i}`} className="label-card">
                <img src={logo} alt={alt} className="label-logo" loading="lazy" />
                <p className="label-text">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="section-blog">
        <div className="fg-inner">
          <div className="blog-header">
            <h2 className="blog-title">Nos dernières activités</h2>
            <Link to="/blog" className="blog-voir-plus">
              Voir plus <span className="blog-arrow" />
            </Link>
          </div>
          <Row gutter={[32, 32]}>
            {ARTICLES.map(({ key, image, date, categorie, titre, description }) => (
              <Col key={key} xs={24} sm={12} lg={8}>
                <Link to={`/blog/${key}`} className="blog-card-link">
                  <div className="blog-card">
                    <div className="blog-card-img-wrap">
                      <img src={image} alt={titre} className="blog-card-img" loading="lazy" />
                    </div>
                    <div className="blog-card-body">
                      <div className="blog-card-meta">
                        <CategorieBadgeBlog categorie={categorie} />
                        <span className="blog-card-date">{date}</span>
                      </div>
                      <div className="blog-card-heading">
                        <h3 className="blog-card-title">{titre}</h3>
                        <span className="blog-card-arrow">↗</span>
                      </div>
                      <p className="blog-card-desc">{description}</p>
                    </div>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      </section>
      <section className="section-faq" id="faq">
        <div className="fg-inner">
          <div className="faq-header" data-sal="slide-up" data-sal-duration="500">
            <h2 className="faq-title">Questions fréquentes</h2>
            <p className="faq-subtitle">Réglementation, fonctionnalités, démarches : toutes vos questions.</p>
          </div>
          <div className="faq-grid">
            {FAQ_CATEGORIES.map((cat, i) => (
              <button
                key={cat.key}
                className={`faq-tile${activeCat === i ? ' faq-tile--active' : ''}`}
                onClick={() => { setActiveCat(i); setOpenFaq(null); }}
              >
                <span className="faq-tile-name">{cat.label}</span>
                <span className="faq-tile-count">{cat.questions.length} question{cat.questions.length > 1 ? 's' : ''}</span>
              </button>
            ))}
          </div>
          <div className="faq-panel" key={activeCat}>

            {FAQ_CATEGORIES[activeCat].questions.map((item, qi) => {
              const isOpen = openFaq === qi;
              return (
                <div key={qi} className={`faq-item${isOpen ? ' faq-item--open' : ''}`}>
                  <button
                    className="faq-question"
                    onClick={() => setOpenFaq(isOpen ? null : qi)}
                    aria-expanded={isOpen}
                  >
                    <span className="faq-question-text">{item.q}</span>
                    <span className="faq-icon" aria-hidden="true">{isOpen ? '−' : '+'}</span>
                  </button>
                  <div className="faq-answer">
                    <p className="faq-answer-text">{item.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="faq-cta">
            <p className="faq-cta-text">Une question qui n'est pas listée ici ?</p>
            <Link to="/contact?tab=info" className="faq-cta-btn">Posez-la nous →</Link>
          </div>
        </div>
      </section>

    </>
  );
}

export default LandingPage;
